import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const OfficeFormsLogo16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1920 0q26 0 49 10t41 27 28 41 10 50v1792q0 27-10 50t-27 40-41 28-50 10H512q-26 0-49-10t-41-27-28-41-10-50v-256H128q-26 0-49-10t-41-27-28-41-10-50V512q0-26 10-49t27-41 41-28 50-10h256V128q0-27 10-50t27-40 41-28 50-10h1408zM512 128v256h640q14 0 28 3t27 9q45-66 115-103t150-37q66 0 124 25t102 68 69 102 25 125q0 66-25 124t-68 102-102 69-125 25q-52 0-101-16t-91-48v192h640V128H512zm960 256q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zM392 1440h215v-310h310V942H607V797h332V608H392v832zm120 480h1408v-768h-640v128h512v512h-512v-256q0 26-10 49t-27 41-41 28-50 10H512v256zm896-256h256v-256h-256v256z" />
    </svg>
  ),
  displayName: 'OfficeFormsLogo16Icon',
});

export default OfficeFormsLogo16Icon;
